import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../components/Spinner';
import SelectSecurityPanel from './SelectSecurityPanel';
import FilingStatesGrid from './FilingStatesGrid';
import ConfirmDialog from '../../../../components/Dialog/ConfirmDialog';
import GenericDialog from '../../../../components/Dialog/GenericDialog';
import FilingRequestForm from '../ClientDetails/components/FilingRequestForm';
import { formInputValidation } from '../../../../services/helper/form-helper';
import {
    setCookie,
    getCookie
} from '../../../../services/helper/cookie-helper';

import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';
import {
    updateNewFilingPayload,
    updateFilingRequestPayload,
    clearFilingsData,
    updateStateSelected,
    fileWithState,
    submitNewFilingRequest,
    submitNewFilingListRequest,
    updateSecuritySelected,
    fetchTrustStates,
    fetchPortfolioStates,
    fetchClassStates,
    fetchProspectusStates,
    updateSelectedStatesList
} from '../../../../services/redux/employee/filing/actions';
import {
    fetchTrustByClient,
    clearTrustsList
} from '../../../../services/redux/employee/trust/actions';
import {
    fetchPortfolioByTrust,
    clearPortfoliosList
} from '../../../../services/redux/employee/portfolio/actions';
import {
    fetchClassesByPortfolio,
    clearClassesList
} from '../../../../services/redux/employee/classes/actions';
import {
    fetchProspectusByClient,
    clearProspectusesList
} from '../../../../services/redux/employee/prospectus/actions';
import Panel from '../../../../components/angle/Panel';

class NewFilingRequest extends Component {
    constructor(props) {
        super(props);
        this.filingFormRef = React.createRef();
        this.state = {
            showFilingReqModal: false,
            showFilingCheckModal: false,
            checkFilingDialogOptions: {
                header: '',
                content: '',
                buttons: []
            },
            dontShowServiceFeeNotifier: false
        };
    }

    componentDidMount() {
        let { fetchAllClientInformationData, location } = this.props;
        fetchAllClientInformationData();

        let dontShowServiceFeeNotifierCookie =
            getCookie('dontShowServiceFeeNotifier') === 'true';

        this.setState({
            dontShowServiceFeeNotifier: dontShowServiceFeeNotifierCookie
        });

        if (!location.from) {
            this.clearComponent();
        }
    }
    clearComponent = () => {
        let {
            clearTrustsList,
            clearProspectusesList,
            clearPortfoliosList,
            clearClassesList,
            clearFilingsData
        } = this.props;
        clearTrustsList();
        clearProspectusesList();
        clearPortfoliosList();
        clearClassesList();
        clearFilingsData();
    };

    updateStateSelected = selected => {
        let { updateStateSelected } = this.props;
        updateStateSelected(selected);

        if (selected) {
            this.setState({
                showFilingReqModal: true
            });
        } else {
            this.setState({
                showFilingReqModal: false
            });
        }
    };

    onSubmitNewFilingClick = () => {
        let { filing, submitNewFilingRequest } = this.props;
        let payload = {
            clientId: filing.newFiling.clientId,
            [filing.selectedSecurity.typeName]: filing.selectedSecurity.id,
            stateId: filing.selectedState.stateId,
            ...filing.filingRequestData
        };
        if (formInputValidation(this.filingFormRef.current)) {
            submitNewFilingRequest(payload).then(response => {
                if (response.data && response.data.filingStatus === 7) {
                    //FilingStatus(7): ExemptionApproved
                    this.setState({
                        showFilingCheckModal: true,
                        checkFilingDialogOptions: {
                            header: 'Accept Exemption',
                            content: 'This filing can be exempted',
                            buttons: [
                                {
                                    text: 'Apply exemption',
                                    onClick: this.onApplyExemptionClick
                                },
                                {
                                    text: 'File with the state anyway',
                                    onClick: this.onFileWithStateClick
                                }
                            ]
                        },
                        filingId: response.data.filingId
                    });
                } else if (response.data && response.data.filingStatus === 8) {
                    //FilingStatus(8): ExemptionQueried
                    this.setState({
                        showFilingCheckModal: true,
                        checkFilingDialogOptions: {
                            header: 'Exemption not available',
                            content: 'This transaction can not be exempted',
                            buttons: [
                                {
                                    text: 'File with the state anyway',
                                    onClick: this.onFileWithStateClick
                                },
                                {
                                    text: 'OK',
                                    onClick: this.onCancelConfirmationClick
                                }
                            ]
                        },
                        filingId: response.data.filingId
                    });
                } else {
                    this.setState({
                        showFilingReqModal: false,
                        showFilingCheckModal: false,
                        checkFilingDialogOptions: {
                            header: '',
                            content: '',
                            buttons: []
                        }
                    });
                    this.refreshStatesList();
                }
            });
        }
    };

    onFileWithStateClick = () => {
        let { fileWithState } = this.props;
        fileWithState(this.state.filingId).then(response => {
            if (response.status === 200) {
                this.setState({
                    showFilingReqModal: false,
                    showFilingCheckModal: false,
                    checkFilingDialogOptions: {
                        header: '',
                        content: '',
                        buttons: []
                    }
                });
                this.refreshStatesList();
            }
        });
    };

    onCancelFilingReqClick = () => {
        let { updateStateSelected } = this.props;
        updateStateSelected({});
        this.setState({
            showFilingReqModal: false
        });
    };

    onCancelConfirmationClick = () => {
        this.setState({
            showFilingReqModal: false,
            showFilingCheckModal: false,
            checkFilingDialogOptions: {
                header: '',
                content: '',
                buttons: []
            }
        });
        this.refreshStatesList();
    };

    onApplyExemptionClick = () => {
        if (!this.state.dontShowServiceFeeNotifier) {
            this.setState({
                showFilingCheckModal: true,
                checkFilingDialogOptions: {
                    header: 'Accept exemption',
                    content: (
                        <div>
                            <p>
                                A service fee will be applied to your account.
                            </p>
                            <div className="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        onChange={this.switchServiceFeeNotifier}
                                        style={{ transform: 'scale(1.5)' }}
                                    />
                                    <em> Don't show this message again</em>
                                </label>
                            </div>
                        </div>
                    ),
                    buttons: [
                        {
                            text: 'OK',
                            onClick: this.onCancelConfirmationClick
                        }
                    ]
                }
            });
        } else {
            this.onCancelConfirmationClick();
        }
    };

    onSubmitNewFilingListClick = () => {
        let { filing, submitNewFilingListRequest } = this.props;
        let selectedStateIds = filing.selectedStates.map(
            state => state.stateId
        );
        let payload = {
            stateIds: selectedStateIds,
            clientId: filing.newFiling.clientId,
            [filing.selectedSecurity.typeName]: filing.selectedSecurity.id
        };

        submitNewFilingListRequest(payload).then(() => {
            this.refreshStatesList();
        });
    };

    switchServiceFeeNotifier = event => {
        const value = event.target.checked;
        setCookie('dontShowServiceFeeNotifier', value, { path: '/' });
        this.setState({
            dontShowServiceFeeNotifier: value
        });
    };

    refreshStatesList = () => {
        let {
            filing,
            fetchTrustStates,
            fetchPortfolioStates,
            fetchClassStates,
            fetchProspectusStates
        } = this.props;
        if (filing.selectedSecurity.typeId === 1) {
            fetchTrustStates(filing.selectedSecurity.id);
        } else if (filing.selectedSecurity.typeId === 2) {
            fetchPortfolioStates(filing.selectedSecurity.id);
        } else if (filing.selectedSecurity.typeId === 3) {
            fetchClassStates(filing.selectedSecurity.id);
        } else if (filing.selectedSecurity.typeId === 4) {
            fetchProspectusStates(filing.selectedSecurity.id);
        }
    };

    render() {
        let {
            clientInformation,
            filing,
            trust,
            portfolio,
            classes,
            prospectus,
            updateFilingRequestPayload,
            updateSelectedStatesList
        } = this.props;
        let { checkFilingDialogOptions } = this.state;
        let fileAllButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSubmitNewFilingListClick}
                disabled={filing.selectedStates.length === 0}
            >
                File all selected
            </button>
        );

        let fileAllButtonNote = (
            <h5>
                <em>
                    {' '}
                    These filings will be non-priority and cannot be exempted.
                </em>
            </h5>
        );

        return (
            <div>
                <div className="row flex-row">
                    <div className="col-md-7">
                        <Panel panelStyle="panel-default mb0">
                            <SelectSecurityPanel />
                        </Panel>
                    </div>
                </div>
                {filing.selectedSecurity.id && (
                    <div className="row flex-row">
                        <div className="col-md-7">
                            <Panel
                                showFooter={true}
                                footerComponents={[
                                    fileAllButton,
                                    fileAllButtonNote
                                ]}
                            >
                                <FilingStatesGrid
                                    dataList={filing.states}
                                    handleButtonClick={this.updateStateSelected}
                                    selectedSecurityType={
                                        filing.selectedSecurity.typeId
                                    }
                                    updateSelected={updateSelectedStatesList}
                                />
                                <ConfirmDialog
                                    header={
                                        'Filing Request - ' +
                                        filing.selectedState.name +
                                        ' - ' +
                                        filing.selectedState.code
                                    }
                                    content={
                                        <div>
                                            <FilingRequestForm
                                                filingRequestData={
                                                    filing.filingRequestData
                                                }
                                                isEditable={true}
                                                updateFileRequestData={
                                                    updateFilingRequestPayload
                                                }
                                                formRef={this.filingFormRef}
                                            />
                                            {filing.fetching && <Spinner />}
                                        </div>
                                    }
                                    confirmButtonText={
                                        filing.filingRequestData
                                            .filingPriorityType === 1
                                            ? 'Check'
                                            : 'File'
                                    }
                                    onConfirm={this.onSubmitNewFilingClick}
                                    onCancel={this.onCancelFilingReqClick}
                                    isShowing={this.state.showFilingReqModal}
                                />
                                <GenericDialog
                                    header={checkFilingDialogOptions.header}
                                    content={
                                        <div>
                                            {checkFilingDialogOptions.content}
                                            {filing.fetching && <Spinner />}
                                        </div>
                                    }
                                    buttons={checkFilingDialogOptions.buttons}
                                    isShowing={this.state.showFilingCheckModal}
                                    showCloseButton={false}
                                />
                            </Panel>
                        </div>
                    </div>
                )}
                {(filing.fetching ||
                    trust.fetching ||
                    portfolio.fetching ||
                    classes.fetching ||
                    prospectus.fetching ||
                    clientInformation.fetching) && <Spinner />}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    trust: state.employee.trust,
    portfolio: state.employee.portfolio,
    classes: state.employee.classes,
    prospectus: state.employee.prospectus,
    filing: state.employee.filing
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            fetchProspectusByClient,
            clearTrustsList,
            clearPortfoliosList,
            clearClassesList,
            clearProspectusesList,
            updateNewFilingPayload,
            updateFilingRequestPayload,
            clearFilingsData,
            updateStateSelected,
            fileWithState,
            submitNewFilingRequest,
            submitNewFilingListRequest,
            updateSecuritySelected,
            fetchTrustStates,
            fetchPortfolioStates,
            fetchClassStates,
            fetchProspectusStates,
            updateSelectedStatesList
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(NewFilingRequest));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/NewFilingRequest/index.js